import React from 'react';
import {Button} from '@homeaway/react-buttons';
import {SVGIcon} from '@homeaway/react-svg';
import classnames from 'classnames';
import './FilterPill.less';

interface FilterPillProps {
    label?: string;
    appliedCount?: number;
    leftAlign?: boolean;
    icon?: string;
    rotateIcon?: boolean;
    applied?: boolean;
    loading?: boolean;
    focused?: boolean;
    onClick?: Function;
    isSelectedFilter?: boolean;
}

/* eslint-disable complexity */
const FilterPill = ({
    label = '',
    appliedCount,
    leftAlign = false,
    rotateIcon = false,
    icon,
    applied = false,
    focused = false,
    loading = false,
    isSelectedFilter = false,
    onClick,
}: FilterPillProps) => {
    if (loading) {
        return (
            <Button
                className="FilterPill"
                disabled
                label={<div className="bg--shimmer FilterPill--loading" />}
                size="xs"
            />
        );
    }

    const svgIcon = <SVGIcon inlineFlex markup={icon} aria-hidden />;

    const className = classnames('FilterPill', {
        'FilterPill--applied': applied,
        'FilterPill--focused': focused,
        'FilterPill--rotate-icon': rotateIcon,
        'FilterPill--selected-filter': isSelectedFilter,
    });

    return (
        <Button
            className={className}
            size="xs"
            onClick={onClick}
            label={
                <>
                    {leftAlign && svgIcon}
                    <span>{label}</span>
                    {!!appliedCount && appliedCount > 0 && (
                        <span className="FilterPill__count">{`(${appliedCount})`}</span>
                    )}
                    {!!isSelectedFilter && (
                        <span className="FilterPill--selected-filter-spacing-mid" />
                    )}
                    {!leftAlign && svgIcon}
                </>
            }
        />
    );
};

export default FilterPill;
